import { cn } from '@/lib/ui/utils';
import {
  type HTMLAttributes,
  type ReactNode,
  type Ref,
  forwardRef,
} from 'react';

type CmsInlineRailProps = {
  as?: 'div' | 'nav' | 'section';
  className?: string;
  children: ReactNode;
} & Omit<HTMLAttributes<HTMLElement>, 'className' | 'children'>;

export const CmsInlineRail = forwardRef<HTMLElement, CmsInlineRailProps>(
  function CmsInlineRail({ as = 'div', className, children, ...props }, ref) {
    const railClassName = cn('cms-inline-rail', className);

    if (as === 'nav') {
      return (
        <nav ref={ref as Ref<HTMLElement>} className={railClassName} {...props}>
          {children}
        </nav>
      );
    }

    if (as === 'section') {
      return (
        <section
          ref={ref as Ref<HTMLElement>}
          className={railClassName}
          {...props}
        >
          {children}
        </section>
      );
    }

    return (
      <div
        ref={ref as Ref<HTMLDivElement>}
        className={railClassName}
        {...props}
      >
        {children}
      </div>
    );
  }
);
